import fp from "lodash/fp"

import type { DevicePlotDef, GeoPlotView } from "types/dashboard.types"

import { mapPlotDefBase } from "helpers/config/dashboards/base/defs"
import { LAT_FIELD, LON_FIELD } from "helpers/config/telemetryFieldDefs"

export const mapView: GeoPlotView = {
  name: "Location",
  nameKey: "LOCATION",
  type: "geo",
  properties: {
    allowPanAndZoom: true,
    showNoteWhenEmpty: false,
    zoom: 6,
    detectCoordinateFields: false,
    useS2CellID: false,
    latLonColumns: {
      lat: {
        key: "field",
        column: LAT_FIELD,
      },
      lon: {
        key: "field",
        column: LON_FIELD,
      },
    },
    layers: [
      {
        type: "pointMap",
        colorDimension: { label: "value" },
        colorField: "_value",
        isClustered: false,
      },
    ],
  },
}

export const mapPlotDef: DevicePlotDef = fp.merge(mapPlotDefBase, {
  view: mapView,
  reqConfig: {
    fields: [LAT_FIELD, LON_FIELD],
    method: ["last"],
    group: ["id", "_field"],
  },
})
